// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import conf from '@/config'
import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment'
import {
  DatePicker
  , Loading
  , Notification
  , Progress
  , MessageBox
  , Message
  , Row
  , Col
  , Button
  , Input
  , Select
  , Option
  , Pagination
  , Table
  , TableColumn
  , Tooltip
  , Dialog
  , Card
  , Checkbox
  , Tabs
  , TabPane
  , Radio
  , Alert } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/es'
import vueCountryRegionSelect from 'vue-country-region-select'
import CountryFlag from 'vue-country-flag'
import locale from 'element-ui/lib/locale'
import '@/assets/element-ui/theme/index.css'
import App from './App'
import apolloProvider from './apollo'
import store from '@/store'
import router from './router'
import bootstrap from '@/core/bootstrap'
import VueStorage from 'vue-ls'
import config from '@/config/defaultSettings'

locale.use(lang)
Vue.prototype.$BACKEND_URL = conf.ENDPOINTS.NEST_BACKEND
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$message = Message
Vue.prototype.$loading = Loading.service
Vue.prototype.$notify = Notification
Vue.use(VueStorage, config.storageOptions)
Vue.use(Loading.directive)
Vue.use(DatePicker, { locale })
Vue.use(Progress, { locale })
Vue.use(Button, { locale })
Vue.use(Select, { locale })
Vue.use(Input, { locale })
Vue.use(Option, { locale })
Vue.use(Pagination, { locale })
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Row)
Vue.use(Tooltip)
Vue.use(Col)
Vue.use(Dialog)
Vue.use(Card)
Vue.use(Checkbox)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Radio)
Vue.use(Alert, { locale })
moment.locale('es')
Vue.use(VueMoment, { moment })
Vue.config.productionTip = false
Vue.use(vueCountryRegionSelect)
Vue.component('country-flag', CountryFlag)

// console.log(store._vm['common/envInfo'])
/* eslint-disable no-new */
new Vue({
  router,
  store,
  created () {
    bootstrap()
  },
  apolloProvider,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js